export interface Tomo {
  numero: string
  titulo: string
  descripcion: string
  valor: string
}

export const tomos: Tomo[] = [
  {
    numero: 'Tomo 1',
    titulo: 'El Código de la Desinflamación',
    descripcion:
      'Identifica los principales hábitos que pueden estar aumentando tu inflamación diaria y aplica el protocolo inicial de 9 días para empezar a sentirte más ligera.',
    valor: '$17 USD',
  },
  {
    numero: 'Tomo 2',
    titulo: 'Blindaje de Glucosa',
    descripcion:
      'Aprende combinaciones simples para comer carbohidratos con más inteligencia, evitar picos de hambre y sentir más estabilidad durante el día.',
    valor: '$17 USD',
  },
  {
    numero: 'Tomo 3',
    titulo: 'El Switch Circadiano',
    descripcion:
      'Organiza tus horarios de comida, descanso y energía para apoyar tu metabolismo sin rutinas imposibles ni cambios extremos.',
    valor: '$17 USD',
  },
  {
    numero: 'Tomo 4',
    titulo: 'Detox Celular y Linfático',
    descripcion:
      'Hábitos sencillos de hidratación, movimiento y alimentación para apoyar los procesos naturales de eliminación de tu cuerpo.',
    valor: '$17 USD',
  },
  {
    numero: 'Tomo 5',
    titulo: 'La Despensa Inteligente',
    descripcion:
      'Listas de compra, alimentos recomendados y sustituciones fáciles para armar comidas prácticas sin vivir contando calorías.',
    valor: '$12 USD',
  },
  {
    numero: 'Tomo 6',
    titulo: 'El Plan Maestro 30 Días',
    descripcion:
      'Menús paso a paso, ideas de comidas rápidas y más de 50 recetas simples para continuar después del reinicio inicial.',
    valor: '$17 USD',
  },
]

export interface Bonus {
  numero: string
  titulo: string
  descripcion: string
  valor: string
}

export const bonuses: Bonus[] = [
  {
    numero: 'Bonus 1',
    titulo: 'Protocolo SOS 24 Horas',
    descripcion:
      'Una guía rápida para esos días en los que sientes más inflamación, pesadez o retención. Ideal para volver al plan sin culpa.',
    valor: '$12 USD',
  },
  {
    numero: 'Bonus 2',
    titulo: 'Comer Fuera Sin Sabotaje',
    descripcion:
      'Guía práctica para elegir mejor en restaurantes, reuniones, viajes o fines de semana sin sentir que arruinaste tu avance.',
    valor: '$12 USD',
  },
  {
    numero: 'Bonus 3',
    titulo: 'Metabolismo en Movimiento',
    descripcion:
      'Micro-rutinas de 7 minutos para activar tu cuerpo en casa, sin gimnasio, sin equipo y sin largas sesiones de cardio.',
    valor: '$12 USD',
  },
  {
    numero: 'Bonus 4',
    titulo: 'Biohacking de Cocina',
    descripcion:
      'Trucos simples para preparar tus comidas de la semana en menos tiempo, con mejores combinaciones y menos decisiones diarias.',
    valor: '$12 USD',
  },
  {
    numero: 'Bonus 5',
    titulo: 'Despensa Libre de Tóxicos',
    descripcion:
      'Checklist para identificar productos, snacks y ultraprocesados que pueden estar saboteando tus hábitos sin que te des cuenta.',
    valor: '$12 USD',
  },
]

export interface TransformationStory {
  imagen: string
  alt: string
  nombre: string
  edad: string
  pais: string
  relato: string
  enfoque: string
}

/**
 * Ilustrativas: perfiles y relatos de ejemplo, no testimonios verificados.
 */
export const transformationStories: TransformationStory[] = [
  {
    imagen: 'https://cdn.magicpatterns.com/uploads/2X3N31HKnMJUQWXDwV4Fnp/IMG_0366.jpg',
    alt: 'Comparativa ilustrativa de dos fotos de abdomen, antes y después',
    nombre: 'Mariana',
    edad: '34 años',
    pais: 'Colombia',
    relato:
      'Dejé de improvisar cada comida. Tener mis combinaciones decididas de antemano me quitó muchísima ansiedad del día a día.',
    enfoque: 'Alimentación con estrategia',
  },
  {
    imagen: 'https://cdn.magicpatterns.com/uploads/wzt4qEA9vL2Qs9R1A2Hz6E/IMG_0367.jpg',
    alt: 'Comparativa ilustrativa de perfil lateral, antes y después',
    nombre: 'Daniela',
    edad: '41 años',
    pais: 'México',
    relato:
      'Ordenar mis horarios fue lo que más me cambió la sensación diaria: dejé de comer a deshora y de llegar con hambre extrema a la noche.',
    enfoque: 'Sueño y horarios',
  },
  {
    imagen: 'https://cdn.magicpatterns.com/uploads/u7rGUWPpvTze1kJMaS5U93/IMG_0368.jpg',
    alt: 'Comparativa ilustrativa de cuerpo completo de frente, antes y después',
    nombre: 'Carolina',
    edad: '38 años',
    pais: 'España',
    relato:
      'Entender cómo combinar los carbohidratos me sacó de la montaña rusa de antojos. Ya no siento que necesito picar todo el tiempo.',
    enfoque: 'Glucosa y combinaciones',
  },
  {
    imagen:
      'https://cdn.magicpatterns.com/uploads/kjt2AUDwCuC3k5RqcSXdnT/c7167f9d1ecabbe1903fde1f475a2dd2.jpg',
    alt: 'Comparativa ilustrativa de perfil lateral con jeans, antes y después',
    nombre: 'Valeria',
    edad: '29 años',
    pais: 'Argentina',
    relato:
      'Empecé a cuidar el descanso y a dejar la comida de la semana resuelta. Hábitos simples, pero que por fin puedo sostener.',
    enfoque: 'Organización diaria',
  },
]

export const transformationPillars: string[] = [
  'Alimentación con estrategia',
  'Glucosa y combinaciones',
  'Sueño y horarios',
  'Antojos y hábitos',
  'Organización diaria',
]

export interface FaqItem {
  pregunta: string
  respuesta: string
}

export const faqs: FaqItem[] = [
  {
    pregunta: '¿Es una dieta keto?',
    respuesta:
      'No. Metabolismo Restart no es una dieta keto ni un plan extremo. Es un protocolo educativo que te enseña a combinar mejor tus comidas, organizar tus horarios y reducir hábitos que pueden estar contribuyendo a la inflamación. Incluye carbohidratos inteligentes y opciones flexibles.',
  },
  {
    pregunta: '¿Tengo que comprar suplementos caros?',
    respuesta:
      'No. El protocolo está diseñado para hacerse con alimentos reales, ingredientes simples y hábitos cotidianos. No necesitas comprar suplementos, pastillas, polvos ni productos especiales para comenzar.',
  },
  {
    pregunta: '¿Funciona si tengo hipotiroidismo?',
    respuesta:
      'El contenido es educativo y puede ayudarte a mejorar hábitos de alimentación, organización de comidas y estilo de vida. Sin embargo, si tienes hipotiroidismo, resistencia a la insulina, diabetes, problemas hormonales o cualquier condición médica, lo ideal es consultar con tu profesional de salud antes de hacer cambios importantes en tu alimentación.',
  },
  {
    pregunta: '¿En cuánto tiempo puedo empezar a sentir cambios?',
    respuesta:
      'El protocolo inicial está diseñado para aplicarse durante 9 días. Muchas personas pueden notar más ligereza, mejor organización en sus comidas y menos sensación de pesadez al seguirlo con constancia. Los resultados pueden variar según cada cuerpo, hábitos previos y nivel de compromiso.',
  },
  {
    pregunta: '¿Voy a bajar de peso con este método?',
    respuesta:
      'Metabolismo Restart no promete una pérdida de peso específica ni garantizada. El enfoque está en ayudarte a reducir inflamación, mejorar tus hábitos y comer de forma más inteligente. En muchas personas, esos cambios pueden reflejarse en una mejor composición corporal, pero cada resultado depende del contexto individual.',
  },
  {
    pregunta: '¿Necesito hacer ejercicio intenso?',
    respuesta:
      'No. No necesitas pasar horas haciendo cardio ni entrenar todos los días. El programa incluye movimiento simple, micro-rutinas y hábitos que puedes adaptar a tu nivel actual.',
  },
  {
    pregunta: '¿Qué recibo exactamente al comprar?',
    respuesta:
      'Recibes acceso digital inmediato a los 6 tomos de la Enciclopedia del Reinicio Metabólico, el protocolo inicial de 9 días, el Plan Maestro de 30 días, más 5 bonus estratégicos para ayudarte a organizar comidas, comer fuera, moverte mejor y mantener el plan de forma simple.',
  },
  {
    pregunta: '¿El acceso es inmediato?',
    respuesta:
      'Sí. Después de completar tu compra, recibes el acceso digital para empezar de inmediato desde tu celular, tablet o computadora.',
  },
  {
    pregunta: '¿Es un pago único o una suscripción?',
    respuesta:
      'Es un solo pago de $17 USD. No hay mensualidades, renovaciones automáticas ni suscripciones ocultas.',
  },
  {
    pregunta: '¿Por cuánto tiempo tendré acceso?',
    respuesta:
      'Tendrás acceso de por vida al contenido digital adquirido, para que puedas revisarlo cada vez que lo necesites y repetir el protocolo cuando quieras.',
  },
  {
    pregunta: '¿Necesito cocinar recetas complicadas?',
    respuesta:
      'No. El plan está pensado para personas ocupadas. Incluye comidas simples, opciones rápidas, listas de compra y combinaciones prácticas para que puedas aplicarlo sin pasar horas en la cocina.',
  },
  {
    pregunta: '¿Qué pasa si no me gusta el contenido?',
    respuesta:
      'Tienes una garantía de satisfacción de 7 días. Si el programa no cumple tus expectativas, puedes solicitar la devolución dentro del periodo indicado.',
  },
]

export const socialProofMessages: string[] = [
  'Ana de Bogotá compró el Protocolo hace 2 min',
  'Carla de Madrid accedió hace 5 min',
  'Valeria de México inició su reinicio hace 1 min',
  'Lucía de Buenos Aires compró el Protocolo hace 3 min',
  'Paola de Lima accedió hace 4 min',
]

export const CHECKOUT_URL =
  'https://metabolismorestartpro.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/agpmeBPVNzgJYQjPWErxWU/ChatGPT_Image_22_ago_2026,_22_41_16.png'
